import React, { useEffect, useRef, useState } from 'react';
import { classIf } from '../data/utils/classIf';
import { iconCategoryCssClass } from '../data/utils/iconCategoryCssClass';
import { scrollToTarget } from '../data/utils/scrollToTarget';

function CategorySelector(props) {
    const [expanded, setExpanded] = useState(false);

    function toggleExpand() {
        setExpanded(!expanded);
        if (expanded) {
            setTimeout(() => {
                if (navbar.current) {
                    const selected = navbar.current.querySelector('.selected');
                    scrollToTarget(navbar.current, selected);
                }
            }, 200);
        }
    }

    const navbar = useRef(null);
    useEffect(() => {
        if (navbar.current) {
            const selected = navbar.current.querySelector('.selected');
            if (navbar.current.firstElementChild !== selected) {
                navbar.current.scrollLeft = selected.getBoundingClientRect().left;
            }
        }
    }, []);
    return (
        <nav className="nav-filters-wrapper">
            <div className={"nav-filters" + classIf(expanded, 'expanded')} ref={navbar}>
                {props.categories && props.categories.map(category => {
                    function handleClick(e) {
                        props.changeCountry(category.id);
                        if (expanded) {
                            setExpanded(!expanded);
                            setTimeout(() => {
                                if (navbar.current) {
                                    scrollToTarget(navbar.current, e.target);
                                }
                            }, 200);
                        }
                    }
                    let icon = iconCategoryCssClass(props.category.sportRef,category.id,category.iconClass);
                    if (category.id === 0) {
                        icon = iconCategoryCssClass(1,4);
                    }

                    return (
                        <div key={category.id} className={"nav-filter-item categoryLiveContainer "+ classIf(category.id === props.category.id, 'selected')} onClick={handleClick}>
                            <div className={`border img-fluid ico-cat iconCategoryLive ${icon}`} ></div>
                            <span>{category.descrizione}</span>
                        </div>
                    ) 
                })}
                {expanded &&
                    <div className="nav-filters-close-button" onClick={toggleExpand}>
                        <i className="far fa-times-circle"></i>
                    </div>
                }
            </div>
            {props.categories && props.categories.length > 3 &&
                <div className="nav-filters-expand-button" onClick={toggleExpand}>
                    <i className="fa fa-angle-down"></i>
                </div>
            }
        </nav>
    );
}

export default CategorySelector;